import { useEffect, useState } from 'react';
import { api } from '../../../lib/api.js';

/**
 * Object URL for one of the agent's own (authenticated) Producer Page images.
 * `<img>` cannot send the bearer token, so fetch as a blob. Refetches when `rev` changes.
 * @param {'profile'|'background'|'license'} kind
 * @param {string} state - US state code for licenses, '' otherwise.
 * @param {boolean} present - Whether the server has this image.
 * @param {number} rev
 * @returns {string} Object URL, or '' while absent/loading.
 */
export function useAssetUrl(kind, state, present, rev) {
  const [url, setUrl] = useState('');
  useEffect(() => {
    if (!present) { setUrl(''); return undefined; }
    let alive = true;
    let made = '';
    api.get(`/producer-page/assets/${kind}${state ? `/${state}` : ''}`, { responseType: 'blob' })
      .then((r) => {
        if (!alive) return;
        made = URL.createObjectURL(r.data);
        setUrl(made);
      })
      .catch(() => { if (alive) setUrl(''); });
    return () => { alive = false; if (made) URL.revokeObjectURL(made); };
  }, [kind, state, present, rev]);
  return url;
}
